/* @flow */
import * as React from 'react';
import { Route } from 'react-router-dom';
import { translate } from 'react-i18next';
import withRouteTracker from 'common/middleware/RouteTracker';
import { Title } from 'common/components/common';

import {
    withRoutePermissionCheck,
    RoleOperationEnum
} from 'common/modules/rbac';

import Products from 'common/enums/Product';
import { lazy } from 'common/modules/mfe';

import SectionWrap from 'common/components/common/SectionWrap';
import { type GetRoutesFn } from './types';

const DispatcherContainer = lazy(() =>
    import('dispatchiq-app/DispatcherContainer')
);

const TrackedDispatcherContainer = withRouteTracker(
    DispatcherContainer,
    Products.DISPATCHER
);

const RosterContainer = lazy(() => import('dispatchiq-app/RosterContainer'));

const TrackedRosterSection = withRouteTracker(
    withRoutePermissionCheck(({ ...rest }) => {
        return (
            <SectionWrap>
                <Title i18nKey="rosterDashboardTitle" />
                <RosterContainer {...rest} />
            </SectionWrap>
        );
    }, RoleOperationEnum.SHOW_ROSTER_SECTION),
    Products.ROSTER
);

const ContractsContainer = lazy(() =>
    import('dispatchiq-app/ContractsContainer')
);
const TrackedContractsSection = withRouteTracker(
    withRoutePermissionCheck(
        translate()(({ ...rest }) => {
            return (
                <SectionWrap>
                    <Title i18nKey="contractsDashboard" />
                    <ContractsContainer {...rest} />
                </SectionWrap>
            );
        }),
        RoleOperationEnum.SHOW_CONTRACTS_SECTION
    ),
    Products.CONTRACTS
);

const getRoutes: GetRoutesFn = ({ match, visibleSections }) => {
    return [
        visibleSections.showBatchSection && (
            <Route
                path={`${match.path}/batch`}
                component={TrackedDispatcherContainer}
            />
        ),

        visibleSections.showContractSection && (
            <Route
                path={`${match.path}/contracts`}
                component={TrackedContractsSection}
            />
        ),

        visibleSections.showRosterSection && (
            <Route
                path={`${match.path}/roster`}
                component={TrackedRosterSection}
            />
        )
    ].filter(Boolean);
};

export default getRoutes;
